module.exports = __webpack_public_path__ + "static/UIColors@2x-947a813c68f6ac5e2b72c5ee70a08a06.jpg";